/*  eslint-disable  */ 
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueClipboard from 'vue-clipboard2'
import Vuelidate from 'vuelidate'

// import router from './router'
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VueClipboard)
Vue.use(Vuelidate)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App />'
})



// WEBPACK FOOTER //
// ./src/main.js